import Image from 'next/image';

import { Box, Flex } from '@chakra-ui/react';

import { GlyphCard } from '~/components/glyph-card';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { Section } from '~/components/section';
import { Logo, LogoGardenSection } from '~/features/plans/components/logo-garden';

type MentorBenefitsSectionProps = {
  title: string;
  partnersDescription: string;
  benefits: {
    title: string;
    glyphName: string;
  }[];
  partners: Logo[];
};

export function MentorBenefitsSection({ title, benefits, partners, partnersDescription }: MentorBenefitsSectionProps) {
  return (
    <Section bgColor='accent.sky.100' overflow='hidden' position='relative'>
      <Box
        left='50%'
        position='absolute'
        top='50%'
        transform='translate(-50%, -50%)'
        display={{
          base: 'none',
          xl: 'block',
        }}
      >
        <Box height='500px' position='relative' width='2080px'>
          <Image
            alt=''
            quality={100}
            sizes='1980px'
            src='/images/backgrounds/lime-lines.svg'
            style={{
              objectFit: 'contain',
              objectPosition: 'center center',
            }}
            fill
          />
        </Box>
      </Box>
      <Flex align='center' direction='column'>
        <HeadingWithEmphasis
          text={title}
          emphasisProps={{
            color: 'blue.500',
            fontWeight: 200,
          }}
          headingProps={{
            mb: 6,
            textAlign: 'center',
            whiteSpace: 'pre-wrap',
            size: 'marketing-5xl',
          }}
        />
        <Flex
          direction={{ base: 'column', md: 'row' }}
          flex={{ base: '1 0 50%' }}
          gap={8}
          justify='center'
          marginTop='40px'
          wrap='wrap'
        >
          {benefits?.map((benefit) => (
            <GlyphCard key={benefit.title} glyphName={benefit.glyphName} title={benefit.title} />
          ))}
        </Flex>
        {partners && (
          <LogoGardenSection
            logos={partners}
            theme='light'
            title={partnersDescription}
            wrapLogos={false}
            boxProps={{
              minHeight: 'auto',
              padding: {
                base: '40px 0px 0',
                md: '64px 0px 0',
              },
            }}
            headingProps={{
              size: 'h4',
              textAlign: { base: 'left', md: 'center' },
            }}
            logoContainerProps={{
              justifyContent: { base: 'left', md: 'center' },
            }}
          />
        )}
      </Flex>
    </Section>
  );
}
